import React from "react";
import { useState, useEffect } from "react";
import { Button, Form, Input, Select, message, DatePicker, Switch } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useParams } from "react-router-dom";
import { LoadTags } from "../../../utils/commonapis";
import PageHeader from "../../../component/pageHeaders";
import Loadingbox from "../../../component/loadingbox";
import { Container, Row, Col } from "react-bootstrap";
import BannerImage from "../components/bannerImages";
import { API } from "../../../config/API";
import axios from "../../../config/axiosInstance";
import moment from "moment";

function QuizCampForm(props: any) {
  const [form] = Form.useForm();
  let { id } = useParams();
  const [isLoading, setIsLoading] = useState<any>(true);
  const [isLoading1, setIsLoading1] = useState<any>(false);
  const [type, setType] = useState(null) as any;
  const [tags, setTags] = useState<any>([]);
  const [data, setData] = useState({}) as any;

  const [description, setDescription] = useState<any>(null);
  const [bannerDesk, setBannerDesk] = useState<any>(null);
  const [bannerMob, setBannerMob] = useState<any>(null);
  const [tagFilter, setTagFilters] = useState("");
  const [loading3, setLoading3] = useState(true);

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        {
          color: ["red", "blue", "yellow"],
        },
      ],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link"],
      ["clean"],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  useEffect(() => {
    if (id !== "create") {
      getData();
    } else {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    loadTags(tagFilter);
  }, [tagFilter]);

  const loadTags = async (searchTerm: any) => {
    setLoading3(true);
    try {
      const res: any = await LoadTags(searchTerm);
      setTags(res);
    } catch (error) {
    } finally {
      setLoading3(false);
    }
  };
  function debounce(func: any, delay: any) {
    let timer: any;
    return (...args: any) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }

  const OnTagSearch = debounce((value: any) => {
    setTagFilters(value);
  }, 200);

  const getData = async () => {
    try {
      if (id !== "create") {
        let url =
          API.BASE_URL + API.QUIZZ_MASTER_DETAILS + id + `?populate[0]=tags`;
        const results = await axios.get(url);
        if (results?.data?.data) {
          let data = results?.data?.data?.attributes;
          setData(data);
          setDescription(data?.description);
          setBannerDesk(data?.bannerDesk);
          setBannerMob(data?.bannerMob);
        }
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
    }
  };

  const Finished = async (type: any) => {
    try {
      setIsLoading1(true);
      setType(type);
      form.submit();
      await form.validateFields();
      let values = form.getFieldsValue();
      var requestObj = {
        data: {
          end_date: values?.end_date,
          end_time: values?.end_time,
          head: values?.head,
          permalink: values?.permalink,
          start_date: values?.start_date,
          start_time: values?.start_time,
          tags: values?.tags,
          title: values?.title,
          is_active: values?.is_active ? true : false,
          winner_selected: values?.winner_selected ? true : false,
          winner_name: values?.winner_name,
          winner_phone: values?.winner_phone,
          winner_address: values?.winner_address,
          description: description,
          bannerDesk: bannerDesk,
          bannerMob: bannerMob,
          publishedAt:
            type === "publish" ? new Date() : data?.publishedAt || null,
        },
      };
      let url =
        id !== "create"
          ? API.BASE_URL + API.QUIZZ_MASTER_EDIT + id
          : API.BASE_URL + API.QUIZZ_MASTER_ADD;
      let method = id !== "create" ? "PUT" : "POST";
      axios({
        method: method,
        url: url,
        data: requestObj,
      })
        .then((response) => {
          setIsLoading1(false);
          if (response?.data?.data?.id) {
            message.success(
              `Quizz ${id !== "create" ? "Updated" : "Created"} Successfully.`
            );
            setTimeout(() => {
              window.location.replace(
                `/Auth/QuizCampForm/${response?.data?.data?.id}`
              );
            }, 200);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading1(false);
        });
    } catch (err) {
      console.log(err);
      setIsLoading1(false);
    }
  };

  return (
    <div style={{ height: "95vh", overflow: "scroll" }}>
      <PageHeader title={"Quiz"} length={"Add New Campaign"} />
      <br />
      <Container>
        {isLoading ? (
          <Loadingbox />
        ) : (
          <div>
            <Form
              form={form}
              initialValues={{
                start_date: data?.start_date && moment(data?.start_date),
                end_date: data?.end_date && moment(data?.end_date),
                head: data?.head,
                permalink: data?.permalink,
                tags: data?.tags?.data?.map((item: any) => item?.id),
                title: data?.title,
                is_active: data?.is_active ? true : false,
                winner_selected: data?.winner_selected ? true : false,
                winner_name: data?.winner_name,
                winner_phone: data?.winner_phone,
                winner_address: data?.winner_address,
              }}
            >
              <Row>
                <Col sm={5}>
                  <label className="newsFormLabels">Title</label>
                  <Form.Item
                    name={"title"}
                    rules={[{ required: true, message: "Required" }]}
                  >
                    <Input placeholder="" size="large" />
                  </Form.Item>
                  <label className="newsFormLabels">Heading</label>
                  <Form.Item
                    name={"head"}
                    rules={[{ required: true, message: "Required" }]}
                  >
                    <Input placeholder="" size="large" />
                  </Form.Item>
                  <label className="newsFormLabels">Perma-Link</label>
                  <Form.Item
                    name={"permalink"}
                    rules={[{ required: true, message: "Required" }]}
                  >
                    <Input placeholder="" size="large" />
                  </Form.Item>
                  <label className="newsFormLabels">Tags</label>
                  <Form.Item
                    name="tags"
                    rules={[{ required: true, message: "Required" }]}
                  >
                    <Select
                      size="large"
                      mode="multiple"
                      style={{ background: "transparent" }}
                      filterOption={(input: any, option: any) =>
                        option?.children
                          ?.toLowerCase()
                          ?.indexOf(input?.toLowerCase()) >= 0
                      }
                      loading={loading3}
                      onSearch={(val) => OnTagSearch(val)}
                    >
                      {tags.length &&
                        tags.map((item: any, index: any) => {
                          return (
                            <Select.Option key={index} value={item.id}>
                              {item.tag}
                            </Select.Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                  <Row>
                    <Col sm={6}>
                      <label className="newsFormLabels">Start Date</label>
                      <Form.Item name={"start_date"}>
                        <DatePicker
                          showTime
                          mode="date"
                          size="large"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col sm={6}>
                      <label className="newsFormLabels">End Date</label>
                      <Form.Item name={"end_date"}>
                        <DatePicker
                          showTime
                          mode="date"
                          size="large"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <br />
                  <h5>
                    <strong>Winner Information</strong>
                  </h5>
                  <hr />
                  <Form.Item
                    name={"winner_selected"}
                    valuePropName={data.winner_selected ? "checked" : "null"}
                  >
                    <Switch />
                  </Form.Item>
                  <label className="newsFormLabels">Full Name</label>
                  <Form.Item name={"winner_name"}>
                    <Input size="large" />
                  </Form.Item>
                  <label className="newsFormLabels">Phone Number</label>
                  <Form.Item name={"winner_phone"}>
                    <Input size="large" />
                  </Form.Item>
                  <label className="newsFormLabels">Address</label>
                  <Form.Item name={"winner_address"}>
                    <Input.TextArea size="large" />
                  </Form.Item>
                </Col>
                <Col sm={7}>
                  <label className="newsFormLabels">Description</label>
                  <ReactQuill
                    style={{ height: "150px" }}
                    theme="snow"
                    value={description}
                    onChange={setDescription}
                    modules={modules}
                  />
                  <br />
                  <br />
                  <div style={{ margin: 5 }} />
                  <Row>
                    <Col sm={6}>
                      <label className="newsFormLabels">Desktop Banner</label>
                      <BannerImage
                        image={bannerDesk}
                        onChagne={(value: any) => setBannerDesk(value)}
                      />
                    </Col>
                    <Col sm={6}>
                      <label className="newsFormLabels">
                        Mobile Banner{" "}
                        <span style={{ color: "grey", fontSize: 10 }}>
                          (optional)
                        </span>
                      </label>
                      <BannerImage
                        image={bannerMob}
                        onChagne={(value: any) => setBannerMob(value)}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col sm={2}>
                  <Form.Item
                    name={"is_active"}
                    valuePropName={data.is_active ? "checked" : "null"}
                  >
                    <Switch />
                  </Form.Item>
                </Col>
                <Col sm={4}></Col>
                <Col sm={6}>
                  <Row>
                    <Col sm={6}>
                      <Button
                        size="large"
                        block
                        style={{ height: 50 }}
                        loading={isLoading1 && type === "save"}
                        onClick={() => Finished("save")}
                      >
                        {id !== "create" ? "Update" : "Save"}
                      </Button>
                    </Col>
                    <Col sm={6}>
                      <Button
                        disabled={data?.publishedAt ? true : false}
                        size="large"
                        block
                        type="primary"
                        style={{ height: 50 }}
                        loading={isLoading1 && type === "publish"}
                        onClick={() => Finished("publish")}
                      >
                        Publish
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        )}
      </Container>
      <br />
      <br />
      <br />
    </div>
  );
}

export default QuizCampForm;
